import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {environment} from "../../environments/environment";
import {MessagesService} from "../app/services/messages.service";

@Injectable({
  providedIn: 'root'
})
export class SmartSummaryApiService {
  readonly BASE_URL = environment.baseUrl;

  constructor(private httpClient: HttpClient,
              private messagesService: MessagesService) {
  }

  public async getLastCalls(): Promise<any[]> {
    try {
      return await firstValueFrom(this.httpClient.get<any>(`${this.BASE_URL}/api/smart-summary-last-calls`));
    } catch (error) {
      this.messagesService.addMessage({text: "Errore durante recupero ultime interrogazioni", type: "error"});
      throw error;
    }
  }

  public async getSmartSummary(numSinistro?: string, smartSummaryId?: string): Promise<any> {
    try {
      let httpParams = new HttpParams();
      if(numSinistro) httpParams =httpParams.append('idSinistro', numSinistro);
      if(smartSummaryId) httpParams =httpParams.append('smartSummaryId', smartSummaryId);
      return await firstValueFrom(this.httpClient.get<any>(`${this.BASE_URL}/api/smart-summary`, {params: httpParams}));
    } catch (error) {
      this.messagesService.addMessage({text: "Errore durante recupero documento", type: "error"});
      return null;
    }
  }

  public async sendSmartSummaryFeedback(polliceSu: boolean, stelle: number | undefined, commento: string | undefined, idSinistro: string, smartSummaryId: string): Promise<any> {
    return await firstValueFrom(this.httpClient.post<any>(`${this.BASE_URL}/api/send-smart-summary-feedback`, {
      polliceSu,
      stelle,
      commento,
      idSinistro,
      smartSummaryId
    }));
  }

  public async downloadSmartSummaryDocument(gedProtocol: string, smartSummaryId: string): Promise<any> {
    try {
      return await firstValueFrom(this.httpClient.get(`${this.BASE_URL}/api/download-smart-summary-document`, {
        params: new HttpParams().set('gedProtocol', gedProtocol).set('smartSummaryId', smartSummaryId),
        responseType: 'json'
      }));
    } catch (error) {
      console.error("Errore durante il download del documento:", error);
      throw error;
    }
  }



}


